<header class="prom-empty-header {logoClass}">
    {#if logoSrc}
        <img class="prom-empty-header__custom-logo" src={logoSrc} alt="" />
    {/if}
</header>

<script>
    /** @type {string} */
    export let logoSrc = '';

    $: logoClass = logoSrc ? '' : `prom-empty-header--itsl`;
</script>
